(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsChatbot0800DigitalController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService', 'ReportsService'];

  function reports ($scope, $http, NotificationService, ReportsService) {
    	var vm = this;
    	$scope.vm = vm;

    vm.loading = false;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.generate = function () {
      $http.get(apiUrl + '/reports/common/Chatbot0800Digital', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.errorHandler(data, 'Erro ao gerar arquivo.');
            return false;
          }

          if (data.indexOf('no_records') >= 0) {
            vm.result = 0;
            NotificationService.warningHandler(data, 'Nenhum arquivo encontrado no período definido.');
            return;
          }

          var filename = headers('Mktzap-Filename');

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' });
          angular.element(document.body).append(anchor);

          var blob = new Blob([data], { type: 'text/csv' });
          var txtUrl = URL.createObjectURL(blob);

          anchor.attr({
            href: txtUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove();
          URL.revokeObjectURL(txtUrl);
        }, function ({ data }) {
          NotificationService.errorHandler(data, 'Erro ao gerar arquivo.');
        })
    };
  }
})();
